var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c(_vm.filtroPorCargoComponente, {
    ref: "filtroDinamicoComponente",
    tag: "componente",
    attrs: {
      "lists": _vm.form.lists
    },
    on: {
      "submit": _vm.buscarAcompanhamentoDeTurmas
    },
    model: {
      value: _vm.form.filters,
      callback: function ($$v) {
        _vm.$set(_vm.form, "filters", $$v);
      },
      expression: "form.filters"
    }
  }), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.headersPorCargo,
      "items": _vm.form.lists.listAcompanhamentoDeTurmas,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps,
      "no-data-text": _vm.noDataText
    },
    scopedSlots: _vm._u([{
      key: `item.acoes`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('sca-tooltip', {
          attrs: {
            "text": "Visualizar",
            "icon": "mdi-eye-outline",
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.goToVisualizarAcompanhamento(item);
            }
          }
        })];
      }
    }], null, true)
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }